export default "__VITE_ASSET__DVnTzQpQ__"